// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"main_wrapper__1gr4i","text_wrapper":"main_text_wrapper__4Thtf","main_wrapper":"main_main_wrapper__3UrQx","footer_wrapper":"main_footer_wrapper__1fCSB"};